export function getSchemaNameFromUrl(schemaUrl: string): string {
  const typeWithFileExt = schemaUrl.slice(schemaUrl.lastIndexOf('/') + 1, schemaUrl.length);
  return typeWithFileExt.slice(0, typeWithFileExt.lastIndexOf('.'));
}



// WEBPACK FOOTER //
// /home/travis/build/inspirehep/record-editor/src/app/shared/utils.ts